import router from "@/router"
import axios from "axios"

export default ({
    namespaced: true,
    state: {
        offices: [],
        office: {},
        currentPage: 1,
        search: '',
        size: 10,
        order: 'created_at',
        add: {},
        totalPages: 0,
        selectedDelete: [],
        errorMessages: []
    },
    mutations: {
        setAllOffices(state, offices) {
            state.offices = offices
            state.totalPages = Math.ceil(offices.total / state.size) || 0
        },
        setOffice(state, office) {
            state.office = office
        }
    },
    actions: {
        async getAll({ commit, rootState, state }) {
            const filter = 'search=' + state.search + '&size=' + state.size + '&order=' + state.order + '&page=' + state.currentPage
            const url = rootState.baseUrl + '/api/v1/offices'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url + '?' + filter, { headers: header })
                .then(response => {
                    commit('setAllOffices', response.data)
                })
                .catch((error) => {
                    console.log(error)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
        async add({ state, rootState }, params) {
            const url = rootState.baseUrl + '/api/v1/offices'
            // console.log(rootState.auth.accessToken)
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.post(url, params, { headers: header })
                .then(response => {
                    this.dispatch('office/getAll')
                })
                .catch((error) => {
                    console.log("ERROR = ", error.response.data)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                    state.errorMessages.push(error.response.data)
                })
        },
        async delete({ state, rootState }, data) {
            const url = rootState.baseUrl + '/api/v1/offices/'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }

            await Promise.all(
                data.map(id => axios.delete(url + id, { headers: header, data: {} }))
            );
            await this.dispatch('office/getAll')
        },
        async get({ commit, rootState, state }, data) {
            const url = rootState.baseUrl + '/api/v1/offices/'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url + data, { headers: header })
                .then(response => {
                    commit('setOffice', response.data)
                })
                .catch((error) => {
                    console.log(error)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                })
        },
        async edit({ state, rootState }, params) {
            const id = state.office.id
            // console.log(params)
            const url = rootState.baseUrl + '/api/v1/offices/' + id
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.patch(url, params, { headers: header })
                .then(response => {
                    this.dispatch('office/getAll')
                })
                .catch((error) => {
                    console.log("ERROR = ", error.response.data)
                    this.dispatch('auth/getRefreshToken', rootState.auth.refreshToken)
                    state.errorMessages.push(error.response.data)
                })
        },
    }
})